export class BasicRoleInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(roleId: string, roleName: string | null);
    constructor(roleId?: string, roleName?: string | null) {
        if (roleId !== undefined) {
            this.id = roleId;
        }

        if (roleName !== undefined) {            
            this.name = roleName;
        }
    }
}